import Ajax from "utils/request/ajax";
import _ from 'lodash';
import { configClient } from 'components/provider/ConfigProvider'

const EmployeeUtil = {

	sendToken: ( mail, { accessTo = 'app', variables = {}, forceEmail = false, onStart = null, onSuccess = null, onError = null } = {} ) => {
		Ajax.request( configClient.url() + '/connection/rest/employee/reset', {
			variables: {
				email: mail,
				forceEmail: forceEmail,
				accessTo: accessTo,
				...variables
			},
			options: {
				ignoreAuth: true
			},
			onStart: () => {
				if( _.isFunction( onStart ) ) {
					onStart();
				}
			},
			onSuccess: ( result ) => {
				if( _.isFunction( onSuccess ) ) {
					onSuccess( result );
				}
			},
			onError: ( result ) => {
				if( _.isFunction( onError ) ) {
					onError( result );
				}
			},
		})
	},
	
	verifyToken: ( mail, token, { variables = {}, onStart = null, onSuccess = null, onError = null } = {} ) => {
		Ajax.request( configClient.url() + '/connection/rest/employee/authenticate', {
			variables: {
				email: mail,
				token: token, ...variables
			},
			options: {
				ignoreAuth: true
			},
			onSuccess: ( result ) => {
				if ( _.isFunction( onSuccess ) ) {
					onSuccess( result );
				}
			},
			onError: ( result ) => {
				if ( _.isFunction( onError ) ) {
					onError( result );
				}
			},
			onStart: () => {
				if ( _.isFunction( onStart ) ) {
					onStart();
				}
			}
		});
	},
	
	uploadImage: ( base64, employeeGuid, { onStart = null, onSuccess = null, onError = null } = {} ) => {
		Ajax.request( configClient.url() + '/connection/rest/employee/upload_image', {
			variables: {
				non_encoded_image: base64,
				guid: employeeGuid
			},
			onSuccess: ( result ) => {
				if( onSuccess !== null ) {
					onSuccess( result );
				}
			},
			onError: ( result ) => {
				if( onError !== null ) {
					onError( result );
				}
			},
			onStart: () => {
				if( onStart !== null ) {
					onStart();
				}
			}
		});
	},
	
	getQrCode: ( { onStart, onSuccess, onError }) => {
		Ajax.request( configClient.url() + '/connection/rest/web_authentication/generate', {
			onSuccess: ( result ) => {
				if( _.isFunction( onSuccess ) ) {
					onSuccess( result );
				}
			},
			onError: ( result ) => {
				if( _.isFunction( onError ) ) {
					onError( result );
				}
			},
			onStart: () => {
				if( _.isFunction( onStart ) ) {
					onStart();
				}
			}
		});
	},
	
	validateQrCode: ( { code, onStart, onSuccess, onError }) => {
		Ajax.request( configClient.url() + '/connection/rest/web_authentication/validate', {
			variables: {
				code: code
			},
			onSuccess: ( result ) => {
				if( _.isFunction( onSuccess ) ) {
					onSuccess( result );
				}
			},
			onError: ( result ) => {
				if( _.isFunction( onError ) ) {
					onError( result );
				}
			},
			onStart: () => {
				if( _.isFunction( onStart ) ) {
					onStart();
				}
			}
		});
	}
}

export default EmployeeUtil;
